const translations = {
  app: {
    default: 'Standaard',
    company: 'Afosto',
    title: 'Orders',
    searchBar: {
      search: {
        label: 'Zoeken',
        placeholder: 'Zoeken',
      },
    },
    switchedTenant: {
      title: 'Organisatie gewisseld',
      message:
        'Je bent van organisatie gewisseld in een ander venster. Klik hieronder op de "Ok" knop, om in het huidige venster te wisselen naar deze organisatie.',
      actions: {
        ok: 'Ok',
      },
    },
    dock: {
      iam: 'Dashboard',
      spl: 'Spooler',
      cnt: 'Files',
      mes: 'Berichten',
      dashboard: 'Afosto',
      notifications: 'Notificaties',
      fulfilment: 'Fulfilment',
      picker: 'Picker',
      spooler: 'Spooler',
      products: 'Producten',
      user: 'Gebruiker',
      wms: 'WMS',
      rel: 'Contacten',
      order: 'Orders',
      messaging: 'Berichten',
      userMenu: {
        signOut: 'Uitloggen',
        selectTenant: 'Selecteer een organisatie',
        searchTenants: {
          placeholder: 'Zoeken naar organisaties',
        },
        addNewTenant: {
          title: 'Nieuwe organisatie toevoegen',
          subtitle: 'Vraag toegang aan voor een nieuwe organisatie',
        },
        emptyTenants: 'Geen organisaties gevonden',
        subtenantForm: {
          description:
            'Voer het e-mailadres in van de organisatie waar je toegang toe wilt verkrijgen.',
          fields: {
            signee: 'E-mailadres',
          },
          actions: {
            cancel: 'Annuleren',
            sent: 'Verstuur verzoek',
          },
        },
        switchTenant: 'Switch organisatie',
      },
      notificationsMenu: {
        none: 'Geen notificaties',
        all: 'Alle notificaties',
      },
    },
    navigation: {
      main: {
        orders: 'Orders',
        invoices: 'Facturen',
        orderLines: 'Orderregels',
        attach: 'Binnenkomende goederen',
        transactions: 'Transacties',
        pricingRules: 'Prijsregels',
        providers: 'Betaalproviders',
        serviceCosts: 'Servicekosten',
      },
    },
    createEmail: {
      title: 'E-mail opstellen',
    },
    confirmSaveEmailAsConcept: {
      title: 'Opslaan als concept?',
      description:
        'Dit bericht is nog niet verstuurd en bevat wijzigingen die nog niet opgeslagen zijn. Je kunt het bericht als concept opslaan om later verder te bewerken.',
    },
    unauthorizedMessage: 'Je hebt geen toestemming om deze informatie in te zien.',
  },
  confirmCancelFormDialog: {
    title: 'Venster verlaten',
    description:
      'Weet je zeker dat je het venster wilt verlaten? Wijzigingen zullen niet worden opgeslagen.',
    buttons: {
      cancel: 'Annuleren',
      leaveWindow: 'Venster verlaten',
    },
  },
  pages: {
    attach: {
      title: 'Binnenkomende goederen',
      emptyMessage: 'Geen items beschikbaar',
      feedback: {
        itemsAttached: 'Binnenkomende goederen gekoppeld',
        itemsNotAttached: 'Binnenkomende goederen kunnen niet worden gekoppeld',
      },
    },
    createCalculation: {
      title: 'Offerte toevoegen',
    },
    referenceSection: {
      title: 'Referentie',
    },
    clientFormSection: {
      title: 'Kanaal',
    },
    orderTagsSection: {
      title: 'Order labels',
      emptyMessage: 'Geen order labels',
      actions: {
        edit: {
          label: 'Wijzigen',
        },
      },
      feedback: {
        orderTagsUpdated: 'Order labels bijgewerkt',
        orderTagsMotUpdated: 'Order labels konden niet worden bijgewerkt',
      },
      fields: {
        tags: 'Order labels',
      },
      orderTagsSettings: {
        title: 'Order labels',
      },
    },
    orderLines: {
      title: 'Orderregels',
      actions: {
        createOrder: 'Op order plaatsen',
      },
      feedback: {
        orderNotCreated: 'Order kan niet worden aangemaakt',
      },
    },
    orderProcessSection: {
      title: 'Proces',
      actions: {
        edit: {
          label: 'Wijzigen',
        },
      },
      processing: {
        allocation: 'Allocatie',
        capture: 'Facturering',
        confirm: 'Bevestigen',
        fulfilment: 'Fulfilment',
      },
      processingOptions: {
        auto: 'Automatisch',
        manual: 'Handmatig',
        none: 'Geen',
      },
      processSettings: {
        title: 'Proces instellingen',
      },
      feedback: {
        processSettingsUpdated: 'Proces instellingen bijgewerkt',
        processSettingsNotUpdated: 'Proces instellingen konden niet worden bijgewerkt',
      },
    },
    pricingAtSection: {
      title: 'Prijsweergave',
    },
    acceptancesSection: {
      title: 'Deponeringen',
    },
    calculationInvoice: {
      title: 'Factuur maken van offerte',
    },
    couponCategories: {
      title: 'Coupons',
      create: {
        button: 'Nieuwe categorie',
      },
      createDrawer: {
        title: 'Nieuwe categorie maken',
      },
      feedback: {
        couponCategoryCreated: 'Coupon categorie aangemaakt',
        couponCategoryNotCreated: 'Coupon categorie kon niet worden aangemaakt',
        couponCategoryUpdated: 'Coupon categorie bijgewerkt',
        couponCategoryNotUpdated: 'Coupon categorie kon niet worden bijgewerkt',
      },
    },
    couponCategoryView: {
      create: {
        button: 'Nieuwe coupon code',
      },
      actions: {
        quickAdd: 'Snel toevoegen',
        customAdd: 'Handmatig toevoegen',
      },
      previewActions: {
        disableCouponCode: 'Coupon uitschakelen',
      },
      breadcrumbs: {
        coupons: 'Coupons',
      },
      createCoupon: {
        title: 'Nieuwe coupon maken',
      },
      viewCoupon: {
        title: 'Coupon code',
      },
      feedback: {
        couponCreated: 'Coupon code aangemaakt',
        couponNotCreated: 'Coupon code kon niet aangemaakt',
        couponDisabled: 'Coupon code uitgezet',
        couponNotDisabled: 'Coupon code kon niet worden uitgezet',
      },
    },
    orders: {
      title: 'Orders',
      create: {
        title: 'Nieuwe Order',
        button: 'Nieuwe order',
      },
      actions: {
        createOrder: 'Nieuwe order',
        createPurchaseOrder: 'Nieuwe inkooporder',
      },
    },
    invoices: {
      title: 'Facturen',
      previewActions: {
        changePaymentStatus: {
          label: 'Betaalstatus wijzigen',
        },
        edit: {
          label: 'Bewerken',
        },
      },
      create: {
        button: 'Nieuwe factuur',
      },
    },
    invoiceItem: {
      totals: {
        subtotal: 'Subtotaal',
        total: 'Totaal',
        vat: 'Btw',
        vatShifted: 'verlegd',
        incl: 'incl.',
        excl: 'excl.',
      },
    },
    orderItem: {
      totals: {
        subtotal: 'Subtotaal',
        total: 'Totaal',
        vat: 'Btw',
        vatShifted: 'verlegd',
        incl: 'incl.',
        excl: 'excl.',
      },
    },
    transactions: {
      title: 'Transacties',
      createTransaction: {
        title: 'Nieuwe transactie',
      },
      create: {
        button: 'Nieuwe transactie',
      },
      feedback: {
        transactionCreated: 'Transactie is aangemaakt',
        transactionNotCreated: 'Transactie kan niet worden aangemaakt',
      },
      paymentLinkDialog: {
        title: 'Betaallink',
        fields: {
          paymentLinkUrl: {
            tooltip: 'Betaallink gekopieerd',
            button: 'Kopieer betaallink',
          },
        },
      },
      preview: {
        openPayment: 'Toon betaallink',
      },
    },
    paymentMethodSection: {
      title: 'Betaalmethode',
      drawer: {
        title: 'Betaalmethode',
      },
    },
    providers: {
      title: 'Betaalproviders',
    },
    contactSection: {
      title: 'Contact',
      personalInformation: 'Persoonlijke informatie',
      phoneNumber: 'Telefoonnummer',
      organisation: 'Organisatie',
    },
    addressSection: {
      title: 'Adressen',
      billing: {
        title: 'Factuuradres',
        emptyMessage: 'Geen factuuradres',
      },
      shipping: {
        title: 'Verzendadres',
        emptyMessage: 'Geen verzendadres',
      },
      target: {
        title: 'Naar',
      },
      source: {
        title: 'van',
      },
      editButton: {
        label: 'Wijzigen',
      },
    },
    customerSection: {
      title: 'Klant',
      moreInfoButton: {
        label: 'Meer info',
      },
    },
    orderInformationSection: {
      title: 'Ordergegevens',
      overview: {
        paymentInformation: {
          title: 'Betaalinformatie',
          paymentMethod: 'Betaalmethode',
          term: 'Term',
          priceGroup: 'Prijsgroep',
        },
        invoiceInformation: {
          title: 'Factuurgegevens',
          discount: 'Korting',
        },
        shippingInformation: {
          title: 'Verzendinformatie',
          shippingDate: 'Verzenddatum',
          shippingMethod: 'Verzendmethode',
        },
      },
    },
    shipmentsSection: {
      title: 'Verzendingen',
    },
    invoicesSection: {
      title: 'Facturen',
    },
    calculationsSection: {
      title: 'Offertes',
      confirmAuthorizeCalculation: {
        title: 'Offerte autoriseren',
        description:
          'Weet je zeker dat je deze offerte wilt autoriseren? Je kunt daarna geen andere offertes meer autoriseren voor deze order.',
      },
      feedback: {
        calculationAuthorized: 'Offerte is geautoriseerd',
        calculationNotAuthorized: 'Offerte kon niet worden geautoriseerd',
        calculationCreated: 'Offerte aangemaakt',
        calculationNotCreated: 'Offerte kon niet worden aangemaakt',
        calculationNoCreditAvailable: 'Te weinig krediet beschikbaar om de offerte te autoriseren',
        calculationNotPaid: 'Er moet nog betaald worden om de offerte te kunnen autoriseren',
      },
    },
    paymentsSection: {
      title: 'Transacties',
      button: {
        create: {
          label: 'Toevoegen',
        },
      },
    },
    validationSection: {
      title: 'Validatie',
      overview: {
        customer: 'Klant',
        system: 'Systeem',
        accountManager: 'AccountManager',
      },
    },
    orderStatusSection: {
      title: 'Status',
      overview: {
        isConfirmed: 'Bevestigd',
        isAccepted: 'Geaccepteerd',
        isFinished: 'Afgerond',
      },
      status: {
        yes: 'Ja',
        no: 'Nee',
      },
    },
    invoiceStatusSection: {
      title: 'Status',
      overview: {
        isConfirmed: 'Bevestigd',
        isPaid: 'Betaald',
        paidAt: 'Betaald op',
        billedAt: 'Gefactureerd op',
      },
      status: {
        yes: 'Ja',
        no: 'Nee',
      },
    },
    orderCommunication: {
      preview: {
        title: 'Conversatie',
      },
    },
    shipmentFormSection: {
      title: 'Verzendopties',
      button: {
        edit: {
          label: 'Wijzigen',
        },
      },
    },
    addressFormSection: {
      title: 'Adres',
      button: {
        create: {
          label: 'Adres toevoegen',
        },
        select: {
          label: 'Adres selecteren',
        },
      },
      billing: {
        title: 'Factuuradres',
      },
      shipping: {
        title: 'Verzendadres',
      },
      target: {
        title: 'Naar',
      },
      source: {
        title: 'Van',
      },
      emptyMessage: 'Nog geen adres geselecteerd',
    },
    orderItemsFormSection: {
      title: 'Producten',
      itemsErrorMessage: 'Producten kunnen niet worden geladen',
      projectionErrorMessage: 'Prijzen kunnen niet worden geladen',
      orderItemsList: {
        emptyMessage: 'Nog geen producten toegevoegd.',
      },
    },
    itemsFormSection: {
      title: 'Producten',
      button: {
        create: {
          label: 'Product toevoegen',
        },
      },
      noItems: 'Nog geen producten toegevoegd.',
    },
    totalsFormSection: {
      title: 'Totalen',
      button: {
        addDiscount: {
          label: 'Korting toevoegen',
        },
        discounts: {
          label: 'Kortingen',
        },
      },
      adjustmentsDrawer: {
        title: 'Kortingen',
        actions: {
          add: {
            label: 'Korting toevoegen',
          },
        },
      },
      totals: {
        subtotal: 'Subtotaal',
        vat: 'Btw',
        ofWhichVat: 'Waarvan btw',
        shiftedVat: 'verlegd',
        total: 'Totaal',
      },
    },
    orderTotalsFormSection: {
      title: 'Totalen',
      projectionErrorMessage: 'Totalen kunnen niet worden geladen',
    },
    createItem: {
      title: 'Item toevoegen',
    },
    editItem: {
      title: 'Item bewerken',
    },
    createPurchaseOrder: {
      title: 'Inkooporder toevoegen',
    },
    createReturnOrder: {
      title: 'Retourorder toevoegen',
    },
    createCancellationOrder: {
      title: 'Annulering toevoegen',
    },
    createOrder: {
      title: 'Order toevoegen',
      feedback: {
        orderNotCreated: 'Order kan niet worden aangemaakt',
      },
    },
    editOrder: {
      title: 'Order bewerken',
      breadcrumbs: {
        orders: 'Orders',
        edit: 'Bewerken',
      },
      cancelDialog: {
        title: 'Annuleer orderbewerking',
        description:
          'Weet je zeker dat je wilt stoppen met het bewerken van deze order? Alle wijzigingen worden ongedaan gemaakt.',
        actions: {
          cancel: 'Annuleren',
          ok: 'Ok',
        },
      },
      products: {
        title: 'Producten',
        button: {
          create: {
            label: 'Product toevoegen',
          },
        },
      },
      feedback: {
        orderNotUpdated: 'Order kan niet worden bijgewerkt',
      },
    },
    createAddress: {
      title: 'Adres toevoegen',
    },
    orderView: {
      breadcrumbs: {
        orders: 'Orders',
      },
      subNavigation: {
        details: 'Details',
        items: 'Items',
        logs: 'Activiteiten',
        communication: 'Communicatie',
      },
      primaryAction: {
        label: 'Bewerken',
      },
      secondaryActions: {
        allocateOrder: 'Voorraad toewijzen',
        confirmOrder: 'Order bevestigen',
        acceptOrder: 'Order accepteren',
        startOrderFulfilment: 'Start fulfilment',
        deleteOrder: 'Verwijderen',
        triggerDataFlow: 'Trigger dataflow',
      },
      sessionDialog: {
        title: 'Checkout sessie gestart',
        fields: {
          sessionUrl: {
            label: 'Sessie url',
            tooltip: {
              copy: 'Kopiëren',
              copied: 'Url gekopieerd',
              email: 'Url mailen',
            },
            button: 'Kopieer sessie url',
          },
        },
      },
      feedback: {
        allocatingOrder: 'Order voorraad toewijzen',
        startOrderFulfilment: 'Start order fulfilment',
        emailConceptSaved: 'E-mail concept opgeslagen',
        emailConceptNotSaved: 'E-mail concept kan niet worden opgeslagen',
        emailSent: 'E-mail verstuurd',
        emailNotSent: 'E-mail kan niet worden verstuurd',
        orderAllocated: 'Order voorraad toegewezen',
        orderNotAllocated: 'Order voorraad kon niet worden toegewezen',
        orderFulfilmentStarted: 'Order fulfilment gestart',
        orderFulfilmentNotStarted: 'Order fulfilment kon niet worden gestart',
        orderConfirmed: 'Order is bevestigd',
        orderNotConfirmed: 'Order kon niet worden bevestigd',
        orderAccepted: 'Order is geaccepteerd',
        orderNotAccepted: 'Order kon niet worden geaccepteerd',
        orderDeleted: 'Order is verwijderd',
        orderNotDeleted: 'Order kon niet worden verwijderd',
        checkoutNotStarted: 'Checkout kon niet worden gestart',
      },
    },
    calculationView: {
      calculationStatusSection: {
        title: 'Status',
      },
      subNavigation: {
        details: 'Details',
        items: 'Items',
        communication: 'Communicatie',
        logs: 'Activiteiten',
      },
      secondaryActions: {
        createInvoice: 'Factuur maken',
      },
      feedback: {
        invoiceNotCreated: 'Factuur kon niet worden aangemaakt',
      },
    },
    createInvoice: {
      title: 'Factuur toevoegen',
      feedback: {
        invoiceNotCreated: 'Factuur kan niet worden aangemaakt',
      },
    },
    editInvoice: {
      title: 'Factuur bewerken',
      breadcrumbs: {
        invoices: 'Facturen',
        edit: 'Bewerken',
      },
      cancelDialog: {
        title: 'Annuleer factuurbewerking',
        description:
          'Weet je zeker dat je wilt stoppen met het bewerken van deze factuur? Alle wijzigingen worden ongedaan gemaakt.',
        actions: {
          cancel: 'Annuleren',
          ok: 'Ok',
        },
      },
      feedback: {
        invoiceNotUpdated: 'Factuur kan niet worden bijgewerkt',
      },
    },
    invoiceView: {
      breadcrumbs: {
        invoices: 'Facturen',
      },
      subNavigation: {
        details: 'Details',
        items: 'Items',
        logs: 'Activiteiten',
        communication: 'Communicatie',
      },
      primaryAction: {
        label: 'Bewerken',
      },
      secondaryActions: {
        changePaymentStatus: 'Betaalstatus wijzigen',
        generatePdf: 'PDF aanmaken',
        triggerDataFlow: 'Trigger dataflow',
      },
      changeToDefinitiveDialog: {
        title: 'Factuur definitief maken',
        message:
          'Weet je zeker dat je deze factuur definitief wilt maken? Je kunt deze factuur daarna niet meer wijzigen.',
        actions: {
          cancel: 'Annuleren',
          change: 'Maak definitief',
        },
      },
      generatePdfProgressDialog: {
        message: 'PDF aanmaken',
      },
      feedback: {
        invoiceChangedToDefinitive: 'Factuur gewijzigd naar definitief',
        invoiceNotChangedToDefinitive: 'Factuur kan niet definitief worden gemaakt',
        invoiceGeneratingPdfFailed: 'De PDF van de factuur kon niet worden aangemaakt',
      },
    },
    addDiscount: {
      title: 'Korting toevoegen',
    },
    orderItems: {
      actions: {
        changeRoute: 'Route wijzigen',
        createOrder: 'Op order plaatsen',
        cancelAllocation: 'Allocatie annuleren',
      },
      routesDialog: {
        title: 'Route wijzigen',
      },
      confirmCancelAllocation: {
        title: 'Items voorraad allocatie annuleren',
        description:
          'Weet je zeker dat je de voorraad allocatie wilt annuleren voor de geselecteerde items? Let op: de voorraad allocatie wordt alleen geannuleerd voor items die beschikbaar zijn en nog niet op een verzending staan.',
      },
      feedback: {
        itemAllocationCancelled: 'Items voorraad allocatie geannuleerd',
        itemAllocationNotCancelled: 'Items voorraad allocatie kon niet worden geannuleerd',
        orderNotCreated: 'Order kan niet worden aangemaakt',
      },
    },
    conversations: {
      createConversation: {
        title: 'Opmerking plaatsen',
      },
      feedback: {
        conversationCreated: 'Opmerking is geplaatst',
        conversationNotCreated: 'Opmerking kan niet worden geplaatst',
      },
    },
    pricingRules: {
      title: 'Prijsregels',
      create: {
        button: 'Nieuwe prijsregel',
      },
      createPricingRule: {
        title: 'Nieuwe prijsregel',
      },
      previewActions: {
        deactivate: 'Deactiveren',
        duplicate: 'Dupliceren',
        edit: 'Bewerken',
      },
      feedback: {
        pricingRuleCreated: 'Prijsregel aangemaakt',
        pricingRuleNotCreated: 'Prijsregel kan niet worden aangemaakt',
        pricingRuleUpdated: 'Prijsregel is bijgewerkt',
        pricingRuleNotUpdated: 'Prijsregel kan niet worden bijgewerkt',
        pricingRuleDeactivated: 'Prijsregel is gedeactiveerd',
        pricingRuleNotDeactivated: 'Prijsregel kan niet worden gedeactiveerd',
      },
    },
    createPricingRule: {
      title: 'Nieuwe prijsregel',
      feedback: {
        pricingRuleCreated: 'Prijsregel aangemaakt',
        pricingRuleNotCreated: 'Prijsregel kan niet worden aangemaakt',
      },
    },
    editPricingRule: {
      title: 'Prijsregel bewerken',
      breadcrumbs: {
        pricingRules: 'Prijsregels',
        edit: 'Bewerken',
      },
      cancelDialog: {
        title: 'Annuleer bewerking prijsregel',
        description:
          'Weet je zeker dat je wilt stoppen met het bewerken van deze prijsregel? Alle wijzigingen worden ongedaan gemaakt.',
        actions: {
          cancel: 'Annuleren',
          ok: 'Ok',
        },
      },
      feedback: {
        pricingRuleUpdated: 'Prijsregel is bijgewerkt',
        pricingRuleNotUpdated: 'Prijsregel kan niet worden bijgewerkt',
      },
    },
    serviceCosts: {
      title: 'Servicekosten',
      create: {
        button: 'Nieuwe servicekosten',
      },
      createServiceCosts: {
        title: 'Nieuwe servicekosten',
      },
      previewActions: {
        deactivate: 'Deactiveren',
        edit: 'Bewerken',
      },
      feedback: {
        serviceCostsCreated: 'Servicekosten aangemaakt',
        serviceCostsNotCreated: 'Servicekosten kunnen niet worden aangemaakt',
        serviceCostsUpdated: 'Servicekosten is bijgewerkt',
        serviceCostsNotUpdated: 'Servicekosten kunnen niet worden bijgewerkt',
        serviceCostsDeactivated: 'Servicekosten is gedeactiveerd',
        serviceCostsNotDeactivated: 'Servicekosten kunnen niet worden gedeactiveerd',
      },
    },
    createServiceCost: {
      title: 'Nieuwe servicekosten',
      feedback: {
        serviceCostCreated: 'Servicekosten aangemaakt',
        serviceCostNotCreated: 'Servicekosten konden niet worden aangemaakt',
      },
    },
    editServiceCost: {
      title: 'Servicekosten bewerken',
      breadcrumbs: {
        serviceCosts: 'Servicekosten',
        edit: 'Bewerken',
      },
      cancelDialog: {
        title: 'Annuleer bewerking servicekosten',
        description:
          'Weet je zeker dat je wilt stoppen met het bewerken van deze servicekosten? Alle wijzigingen worden ongedaan gemaakt.',
        actions: {
          cancel: 'Annuleren',
          ok: 'Ok',
        },
      },
      feedback: {
        serviceCostUpdated: 'Servicekosten zijn bijgewerkt',
        serviceCostNotUpdated: 'Servicekosten kunnen niet worden bijgewerkt',
      },
    },
    transactionView: {
      breadcrumbs: {
        transactions: 'Transacties',
      },
      subNavigation: {
        details: 'Details',
        logs: 'Activiteiten',
      },
      secondaryActions: {
        refund: 'Terugbetalen',
      },
      feedback: {
        paymentRefunded: 'Betaling terugbetaald',
        paymentNotRefunded: 'Betaling kon niet worden terugbetaald',
      },
      confirmRefund: {
        title: 'Betaling terugbetalen',
        description: 'Weet je zeker dat je deze betaling wil terugbetalen?',
      },
      confirmExecuteRefund: {
        title: 'Terugbetalen',
        description: 'Wil je de betaling parkeren of direct terugbetalen?',
      },
    },
    transactionDetails: {
      details: {
        title: 'Transactie',
        reference: 'Referentie',
        description: 'Omschrijving',
        amountDue: 'Te betalen bedrag',
        amountPaid: 'Betaald bedrag',
        isPaid: 'Betaald',
        returnUrl: 'Terugsturen naar URL',
        webhookUrl: 'Webhook URL',
        secret: 'Sleutel',
        paymentUrl: 'Betaallink',
        client: 'Kanaal',
        createdAt: 'Aangemaakt op',
        order: 'Order',
      },
      payments: {
        title: 'Betalingen',
      },
      confirmExecuteRefund: {
        title: 'Terugbetalen',
        description: 'Weet je zeker dat je deze betaling wilt terugbetalen?',
      },
      feedback: {
        paymentRefunded: 'betaling is terugbetaald',
        paymentNotRefunded: 'betaling kon niet worden terugbetaald',
      },
    },
    selectAddress: {
      billing: {
        title: 'Selecteer factuuradres',
      },
      shipping: {
        title: 'Selecteer verzendadres',
      },
    },
  },
  refundDialog: {
    title: 'Terugbetalen',
    choosePayment: 'Kies een betaling om terug te betalen.',
    chooseAmountToRefund: 'Vul het bedrag in dat je terug wil betalen.',
    enterTransactionTotal: 'Transactie totaal invullen',
    actions: {
      otherPayment: 'Andere betaling',
    },
  },
  contactFormSection: {
    title: 'Contact',
    search: {
      placeholder: 'Contact zoeken',
    },
    address: {
      billing: 'Factuuradres',
      shipping: 'Verzendadres',
    },
    button: {
      create: {
        label: 'Nieuw contact',
      },
    },
  },
  organisationFormSection: {
    title: 'Organisatie',
    button: {
      create: {
        label: 'Nieuwe organisatie',
      },
    },
  },
  addressFormSection: {
    title: 'Adres',
    button: {
      create: {
        label: 'Adres toevoegen',
      },
      select: {
        label: 'Adres selecteren',
      },
    },
    billing: {
      title: 'Factuuradres',
    },
    shipping: {
      title: 'Verzendadres',
    },
    target: {
      title: 'Naar',
    },
    source: {
      title: 'Van',
    },
    emptyMessage: 'Nog geen adres geselecteerd',
  },
  selectAddress: {
    title: 'Adres selecteren',
    button: {
      create: 'Adres toevoegen',
    },
    groups: {
      contact: 'Contact',
      organisation: 'Organisatie',
      other: 'Overig',
    },
  },
  costOverviewSection: {
    title: 'Kostenoverzicht',
    options: {
      currentPrices: 'Huidige prijzen',
    },
    overview: {
      post: 'Post',
      amount: 'Bedrag',
      itemTotal: 'Totaal artikelen',
      shippingCost: 'Verzendkosten',
      discount: 'Korting',
      subtotal: 'Subtotaal',
      total: 'Totaal',
      vat: 'Btw',
      ofWhichVat: 'Waarvan btw',
      shiftedVat: 'verlegd',
    },
  },
  orderForm: {
    feedback: {
      calculationNotCreated: 'Offerte kan niet worden aangemaakt',
    },
    createCalculationProgressDialog: {
      message: 'Offerte aanmaken',
    },
  },
  createContact: {
    title: 'Nieuw contact',
    feedback: {
      contactCreated: 'Contact is aangemaakt',
      contactNotCreated: 'Contact kon niet worden aangemaakt',
    },
  },
  createOrganisation: {
    title: 'Organisatie toevoegen',
    feedback: {
      organisationCreated: 'Organisatie is aangemaakt',
      organisationNotCreated: 'Organisatie kon niet worden aangemaakt',
    },
  },
  createAddress: {
    title: 'Adres toevoegen',
    feedback: {
      addressCreated: 'Adres is toegevoegd',
      addressNotCreated: 'Adres kon niet worden toegevoegd',
    },
  },
  editItemForm: {
    addAdjustmentButton: {
      label: 'Korting toevoegen',
    },
  },
  pricingRuleForm: {
    adjustmentsFormSection: {
      title: 'Kortingen',
    },
    constraintsFormSection: {
      title: 'Restricties',
    },
    filtersFormSection: {
      title: 'Condities',
    },
    types: {
      enhanced: 'Uitgebreid',
      coupon: 'Kortingscode',
      shippingCosts: 'Verzendkosten',
    },
    constraints: {
      buttons: {
        create: 'Beperking toevoegen',
      },
    },
    filters: {
      buttons: {
        create: 'Filter toevoegen',
      },
    },
    adjustments: {
      buttons: {
        create: 'Korting toevoegen',
      },
    },
    constraintTypes: {
      quantity: 'Aantal',
      amount: 'Bedrag',
      client: 'Kanaal',
      filteredAmount: 'Gefilterd bedrag',
      tags: 'Labels',
      shippingMethod: 'Verzendmethode',
      paymentMethod: 'Betaalmethode',
      coupon: 'Kortingscode',
    },
    filterTypes: {
      sku: 'SKU',
      filter: 'Filter',
      isDiscounted: 'Toepasbaar op korting',
      per: 'Per',
    },
    applyToOptions: {
      linesHandling: 'Verwerkingskosten',
      linesShipping: 'Verzendkosten',
      linesCheapest: 'Goedkoopste regels',
      linesAll: 'Alle regels',
      filterResult: 'Gefilterde regels',
      filterCheapest: 'Goedkoopste gefilterde regels',
    },
  },
  serviceCostForm: {
    vatSettingsFormSection: {
      title: 'Btw instellingen',
      fields: {
        type: {
          label: 'Type',
        },
        rate: {
          label: 'Tarief',
        },
        countryCode: {
          label: 'Land',
        },
      },
    },
    filtersFormSection: {
      title: 'Condities',
    },
    constraintTypes: {
      quantity: 'Aantal',
      amount: 'Bedrag',
      client: 'Kanaal',
      filteredAmount: 'Gefilterd bedrag',
      tags: 'Tags',
      shippingMethod: 'Verzendmethode',
      paymentMethod: 'Betaalmethode',
      coupon: 'Kortingscode',
    },
    constraintsFormSection: {
      title: 'Restricties',
    },
    types: {
      handling: 'Betaalkosten',
      shipping: 'Verzendkosten',
    },
    vatTypes: {
      weighed: 'Gewogen',
      fixed: 'Vast',
      max: 'Max',
    },
    constraints: {
      buttons: {
        create: 'Beperking toevoegen',
      },
    },
    filterTypes: {
      sku: 'SKU',
      filter: 'Filter',
      isDiscounted: 'Toepasbaar op korting',
      per: 'Per',
    },
  },
  conversationList: {
    title: 'Opmerkingen',
    emptyMessage: 'Nog geen opmerkingen',
    actions: {
      addComment: 'Opmerking plaatsen',
    },
    feedback: {
      conversationCreated: 'Opmerking is geplaatst',
      conversationNotCreated: 'Opmerking kan niet worden geplaatst',
    },
  },
  stackItemList: {
    title: 'Producten',
    button: {
      create: {
        label: 'Toevoegen',
      },
    },
    actions: {
      remove: {
        label: 'Verwijderen',
      },
    },
    createItem: {
      title: 'Product toevoegen',
    },
    emptyMessage: 'Nog geen producten toegevoegd',
  },
  addProductDrawer: {
    title: 'Product toevoegen',
  },
  collapseAdjustment: {
    title: 'Korting',
  },
  files: {
    title: 'Bestanden',
    emptyMessage: 'Nog geen bestanden geupload',
    actions: {
      download: {
        label: 'Downloaden',
      },
      delete: {
        label: 'Verwijderen',
      },
      print: {
        label: 'Printen',
      },
      uploadToStorage: {
        label: 'Uploaden naar',
      },
    },
    confirmDeleteFile: {
      title: 'Bestand verwijderen',
      description: 'Weet je zeker dat je dit bestand wilt verwijderen?',
      buttons: {
        cancel: 'Annuleren',
        delete: 'Verwijderen',
      },
    },
    printingFileFailedDialog: {
      title: 'Printen van bestand mislukt',
      message: 'Het bestand kon niet worden geprint',
    },
    printFileProgressDialog: {
      description: 'Bezig met printen van bestand...',
    },
    feedback: {
      fileDeleted: 'Bestand is verwijderd',
      fileNotDeleted: 'Bestand kon niet worden verwijderd',
      filePrinted: 'Bestand is geprint',
      fileUploaded: 'Bestand geüpload',
      fileNotUploaded: 'Bestand kon niet worden geüpload',
    },
  },
  printingFailedDialog: {
    actions: {
      close: 'Sluiten',
      download: 'Downloaden',
      retry: 'Opnieuw',
    },
  },
  printerDialog: {
    title: 'Selecteer een printer',
    actions: {
      cancel: 'Annuleren',
    },
  },
  storageUploadDialog: {
    title: 'Bestand uploaden naar',
  },
  dataList: {
    pagination: {
      currentPageLabel: 'Pagina {page}',
      previousPageLabel: 'Vorige pagina',
      nextPageLabel: 'Volgende pagina',
    },
    selection: {
      actions: {
        selectAll: 'Alles selecteren',
        deselectAll: 'Alles deselecteren',
      },
    },
  },
  viewSelection: {
    title: 'Opgeslagen views',
    actions: {
      setAsDefault: 'Instellen als standaard',
    },
    confirmDeleteView: {
      title: 'View verwijderen',
      description: 'Weet je zeker dat je deze view wilt verwijderen?',
      buttons: {
        cancel: 'Annuleren',
        delete: 'Verwijderen',
      },
    },
  },
  filterSelection: {
    title: 'Filters',
    resetButton: 'Reset filters',
    rowCount: '{count} van {total}',
    filterSelectionItem: {
      cancelButton: 'Annuleren',
      saveButton: 'Opslaan',
      createButton: 'Toevoegen',
      newFilterHeader: 'Filter toevoegen',
    },
  },
  dataGrid: {
    defaultView: {
      name: 'Standaard',
      description: 'Standaard weergave',
    },
    columns: {
      auditLogs: {
        actor: 'Gebruiker',
        action: 'Actie / Code',
        url: 'Url',
        resource: 'Bron',
        stream: 'Stream',
        trace: 'Trace',
        category: 'Categorie',
        processedAt: 'Verwerkt op',
        createdAt: 'Aangemaakt op',
      },
      orderLines: {
        address: 'Adres',
        sku: 'SKU',
        description: 'Omschrijving',
        quantity: 'Aantal',
        skus: "SKU's",
        itemIds: 'Items',
        orderIds: 'Orders',
        orderCount: 'Aantal orders',
        isUnavailable: 'Niet beschikbaar',
        isBackorder: 'Backorder',
        isBackordered: 'Gebackordered',
        isInbound: 'Inkomend',
        shipments: 'Verzendingen',
        routes: 'Routes',
        target: 'Target',
        backorders: 'Backorders',
        backorderCount: 'Aantal backorders',
        shipmentCount: 'Aantal verzendingen',
      },
      orders: {
        amount: 'Bedrag',
        number: 'Ordernummer',
        isConfirmed: 'Bevestigd',
        is_confirmed: 'Bevestigd',
        isAccepted: 'Geaccepteerd',
        is_accepted: 'Geaccepteerd',
        isApproved: 'Goedgekeurd',
        is_approved: 'Goedgekeurd',
        isFinished: 'Afgerond',
        is_finished: 'Afgerond',
        is_calculation_valid: 'Valide offerte',
        isCalculationValid: 'Valide offerte',
        customer: 'Klant',
        client: 'Kanaal',
        client_id: 'Kanaal',
        organisation: 'Organisatie',
        organisation_id: 'Organisatie',
        createdAt: 'Aangemaakt op',
        created_at: 'Aangemaakt op',
        updated_at: 'Bijgewerkt op',
        contact_id: 'Klant',
        due_at: 'Verloopt op',
        delivery_at: 'Verwachte levering op',
        progress_allocation: 'Allocatie voortgang',
        progress_capture: 'Facturering voortgang',
        progress_fulfilment: 'Fulfilment voortgang',
        total: 'Totaal',
        search: 'Zoeken',
        reference: 'Referentie',
        last_accepted_at: 'Laatst geaccepteerd op',
        last_confirmed_at: 'Laatst bevestigd op',
        order_tags: 'Order labels',
      },
      couponCategories: {
        categoryName: 'Categorie naam',
        expiresAfter: 'Vervalt na aantal dagen',
        isUnlimited: 'Ongelimiteerd',
        limit: 'Limiet',
        createdAt: 'Aangemaakt op',
        updatedAt: 'Bijgewerkt op',
      },
      couponCodes: {
        code: 'Code',
        isUnlimited: 'Ongelimiteerd',
        remaining: 'Resterend',
        expiresAt: 'Verloopt op',
        updatedAt: 'Bijgewerkt op',
      },
      acceptances: {
        amount: 'Bedrag',
        isPaid: 'Betaald',
        isSettlement: 'Verrekening',
        calculation: 'Offerte',
        transaction: 'Transactie',
        payment: 'Betaling',
        acceptedAt: 'Geaccepteerd op',
        createdAt: 'Aangemaakt op',
      },
      calculations: {
        number: 'Offertenummer',
        total: 'Totaal',
        isValid: 'Valide',
        isAccepted: 'Geaccepteerd',
        isConfirmed: 'Bevestigd',
        createdAt: 'Aangemaakt op',
      },
      transactions: {
        reference: 'Referentie',
        description: 'Omschrijving',
        amountDue: 'Te betalen bedrag',
        amountPaid: 'Betaald bedrag',
        isPaid: 'Betaald',
        createdAt: 'Gestart op',
        company: 'Bedrijf',
        payments: 'Betalingen',
        methods: 'Betaalmethodes',
        entityType: 'Type',
        number: 'Transactienummer',
        client: 'Kanaal',
      },
      invoices: {
        number: 'Factuurnummer',
        contact_id: 'Klant',
        contact: 'Klant',
        organisation: 'Organisatie',
        organisation_id: 'Organisatie',
        amount: 'Bedrag',
        billedAt: 'Gefactureerd op',
        createdAt: 'Aangemaakt op',
        created_at: 'Aangemaakt op',
        invoicedAt: 'Gefactureerd op',
        itemCount: 'Items',
        currency: 'Valuta',
        isConcept: 'Concept',
        isIncludingVat: 'Inclusief btw',
        is_including_vat: 'Inclusief btw',
        is_vat_shifted: 'Btw verlegd',
        isVatShifted: 'Btw verlegd',
        isPaid: 'Betaald',
        is_paid: 'Betaald',
        paidAt: 'Betaald op',
        paid_at: 'Betaald op',
        subtotal: 'Subtotaal',
        total: 'Totaalbedrag',
        reference: 'Referentie',
        description: 'Beschrijving',
        client_id: 'Kanaal',
        client: 'Kanaal',
        search: 'Zoeken',
      },
      shipments: {
        number: 'Verzendnummer',
        isOutbound: 'Uitgaand',
        isDelivered: 'Geleverd',
        isFinished: 'Afgerond',
        expectedAt: 'Verwacht op',
        createdAt: 'Aangemaakt op',
      },
      payments: {
        reference: 'Referentie',
        providerCode: 'Provider',
        methodCode: 'Methode',
        issuerCode: 'Issuer',
        isRefund: 'Retour',
        isPaid: 'Betaald',
        paidAt: 'Betaald op',
        method: 'Methode',
        amount: 'Bedrag',
        createdAt: 'Datum',
      },
      items: {
        address: 'Adres',
        image: 'Afbeelding',
        sku: 'SKU',
        description: 'Omschrijving',
        quantity: 'Aantal',
        orders: 'Orders',
        backorders: 'Backorders',
        orderCount: 'Aantal orders',
        backorderCount: 'Aantal backorders',
        shipmentCount: 'Aantal verzendingen',
        invoices: 'Facturen',
        shipments: 'Verzendingen',
        isUnavailable: 'Niet beschikbaar',
        isAvailable: 'Beschikbaar',
        isBackorder: 'Backorder',
        isBackordered: 'Gebackordered',
        isInbound: 'Inkomend',
        isReservation: 'Reservering',
        claimedAt: 'Geclaimd op',
        route: 'Route',
        deliveryRoute: 'Bezorgroute',
        collectRoute: 'Verzamelroute',
        transfer: 'Transfer',
        target: 'Target',
        origin: 'Herkomst',
        transports: 'Transport',
      },
      conversations: {
        event: 'Type',
        participantNames: 'Deelnemers',
        startedAt: 'Gestart op',
        expiresAt: 'Verloopt op',
      },
      pricingRules: {
        name: 'Naam',
        applyTo: 'Van toepassing op',
        grantLimit: 'Limiet',
        priority: 'Prioriteit',
        activeAt: 'Actief vanaf',
        expiresAt: 'Verloopt op',
        createdAt: 'Aangemaakt op',
      },
      serviceCosts: {
        name: 'Naam',
        type: 'Type',
        priority: 'Prioriteit',
        value: 'Waarde',
        activeAt: 'Actief vanaf',
        expiresAt: 'Verloopt op',
      },
      providers: {
        name: 'Naam',
        code: 'Code',
        isActive: 'Actief',
        isConfigured: 'Ingesteld',
      },
    },
    sortSelection: {
      title: 'Sortering',
      resetButton: 'Reset sortering',
    },
    sortDirections: {
      asc: 'Oplopend',
      desc: 'Aflopend',
    },
    sortOptionSelectionItem: {
      cancelButton: 'Annuleren',
      saveButton: 'Opslaan',
      createButton: 'Toevoegen',
      newSortOptionHeader: 'Sortering toevoegen',
    },
    filters: {
      label: {
        between: '{name} tussen {first} en {second}',
      },
    },
    filterOperators: {
      is: 'Is gelijk aan',
      in: 'Bevat',
      missing: 'Bevat geen waarde',
      not_in: 'Bevat niet',
      gt: 'Is groter dan',
      gte: 'Is groter dan of gelijk aan',
      lt: 'Is kleiner dan',
      lte: 'Is kleiner dan of gelijk aan',
      between: 'Is tussen',
    },
    filterValues: {
      noValue: 'geen waarde',
    },
    filterConjunctions: {
      and: 'en',
    },
    columnSelection: {
      title: 'Kolommen',
      searchField: {
        placeholder: 'Zoeken ...',
      },
      addColumn: {
        label: 'Kolom toevoegen',
      },
      availableColumns: {
        label: 'Beschikbare kolommen',
      },
      selectedColumns: {
        label: 'Geselecteerde kolommen',
      },
      resetButton: 'Reset kolommen',
    },
    addColumn: {
      title: 'Kolom toevoegen',
      inputs: {
        name: {
          label: 'Naam',
        },
        formula: {
          label: 'Formule',
        },
      },
      buttons: {
        cancel: 'Annuleren',
        save: 'Opslaan',
      },
    },
    gridActions: {
      view: {
        title: 'Views',
        settings: 'Instellingen',
        views: 'Views',
        showMore: 'Toon meer',
        saveAs: 'Opslaan als',
        manageSettings: 'Beheren',
        defaultSettings: 'Terugzetten naar standaard',
      },
      columnSelection: {
        title: 'Kolommen',
      },
      sorting: {
        title: 'Sortering',
      },
      dataExport: {
        title: 'Exporteren',
        currentColumns: 'Huidige kolommen',
        allColumns: 'Alle kolommen',
        csv: 'CSV',
        excel: 'Excel',
        pdf: 'PDF',
      },
      dataImport: {
        title: 'Importeren',
      },
      copyGridUrl: {
        title: 'URL kopiëren',
        tooltip: 'Url gekopieerd',
      },
    },
    search: {
      placeholder: 'Zoek',
      exactMatch: 'Exacte match: {state}',
    },
    selection: {
      button: {
        all: 'Alles',
      },
      selected: '{count} van {total} geselecteerd',
    },
    pagination: {
      currentPageLabel: 'pagina {page}',
      previousPageLabel: 'Vorige pagina',
      nextPageLabel: 'Volgende pagina',
      displayedRows: '{from} - {to} van {count}',
      rowsPerPage: 'Rijen per pagina:',
      many: 'veel',
    },
    exportSelection: {
      title: 'Exporteren',
    },
    views: {
      label: {
        system: 'Systeem',
        private: 'Privé',
      },
    },
    viewSelectionMenu: {
      activeView: {
        label: 'Weergave',
      },
    },
    saveView: {
      title: 'Weergave opslaan als',
      showViewInformation: {
        button: {
          show: 'Toon informatie',
          hide: 'Verberg informatie',
        },
        columns: 'Kolommen',
        filters: 'Filters',
        sorting: 'Sortering',
        itemsPerPage: 'Rijen per pagina',
      },
      inputs: {
        name: {
          label: 'Naam',
          helperText: 'Gebruik een bestaande naam om de weergave te overschrijven',
        },
        saveViewForTenant: {
          label: 'Beschikbaar voor elke gebruiker',
        },
      },
      buttons: {
        cancel: 'Annuleren',
        save: 'Opslaan',
      },
    },
  },
  confirmDeleteOrder: {
    title: 'Order verwijderen',
    description: 'Weet je zeker dat je deze order wilt verwijderen?',
  },
  ShippingDetailsSection: {
    title: 'Verzendinformatie',
  },
  contactInformation: {
    title: 'Contact',
    personalInformation: 'Persoonlijke informatie',
    phoneNumber: 'Telefoonnummer',
    organisation: 'Organisatie',
    vatNumber: 'BTW-nummer',
    emptyMessage: 'Geen contact informatie',
  },
  calculationInvoiceForm: {
    itemDrawer: {
      title: 'Item wijzigen',
    },
  },
  vendorSection: {
    title: 'Verkoper',
  },
  paymentStatusDrawer: {
    title: 'Betaalstatus wijzigen',
    feedback: {
      paymentStatusChanged: 'Betaalstatus gewijzigd',
      paymentStatusNotChanged: 'Betaalstatus kan niet worden gewijzigd',
    },
  },
  orderTypeDialog: {
    title: 'Selecteer het type order',
  },
  orderTypeOptions: {
    cart: 'Winkelmandje',
    order: 'Order',
    purchase: 'Inkoop',
    cancellation: 'Annulering',
    return: 'Retour',
    pos: 'Kassa',
    bol: 'Bol.com',
  },
  cancelOrderProgressDialog: {
    message: 'Order annuleren',
  },
  confirmCancelOrder: {
    title: 'Order annuleren',
    description: 'Weet je zeker dat je deze order wilt annuleren?',
    feedback: {
      orderCancelled: 'Order geannuleerd',
      orderNotCancelled: 'Order kan niet worden geannuleerd',
    },
  },
  forceCancelOrderDialog: {
    title: 'Order geforceerd annuleren',
    description: 'Weet je zeker dat je deze order geforceerd wilt annuleren?',
    warningDescription:
      'Weet je zeker dat je deze order geforceerd wilt annuleren? Dit kan mogelijk invloed hebben op onderstaande punten:',
    warnings: {
      transportsShipped:
        'De transporten voor deze order zijn mogelijk al onderweg naar een locatie',
    },
  },
  actions: {
    add: 'Toevoegen',
    addManually: 'Handmatig toevoegen',
    back: 'Terug',
    bulkAdd: 'Bulk toevoegen',
    edit: 'Wijzigen',
    remove: 'Verwijderen',
    cancel: 'Annuleren',
    close: 'Sluiten',
    delete: 'Verwijderen',
    filter: 'Filter',
    goToList: 'Bekijk overzicht',
    save: 'Opslaan',
    authorize: 'Autoriseren',
    continue: 'Doorgaan',
    refresh: 'Opnieuw laden',
    upload: 'Uploaden',
    view: 'Bekijken',
    discard: 'Niet opslaan',
    cancelOrder: 'Order annuleren',
    random: 'Random',
    copied: 'Gekopieerd naar klembord',
    refund: 'Terugbetalen',
    park: 'Parkeren',
  },
  pagination: {
    pageNumber: 'Pagina {i}',
  },
  formActions: {
    cancel: 'Annuleren',
    save: 'Opslaan',
    saveWithoutCalculation: 'Opslaan zonder offerte',
    send: 'Verstuur',
  },
  operators: {
    is: 'Is gelijk aan',
    in: 'Bevat',
    gt: 'Is groter dan',
    gte: 'Is groter dan of gelijk aan',
    lt: 'Is kleiner dan',
    lte: 'Is kleiner dan of gelijk aan',
    between: 'Is tussen',
  },
  arrayField: {
    actions: {
      add: 'Toevoegen',
      remove: 'Verwijderen',
    },
  },
  applicationUpdateNotification: {
    updateAvailableMessage: 'Nieuwe versie van de app beschikbaar',
    updateButton: {
      label: 'Bijwerken',
    },
  },
  dateOptions: {
    today: 'Vandaag',
    relativeNow: 'Relatief vanaf nu',
    relative: 'Relatief',
    date: 'Datum',
  },
  fileUpload: {
    labelIdle:
      'Sleep & upload bestanden of <span class="filepond--label-action"> selecteer bestanden </span>',
    labelInvalidField: 'Veld bevat niet ondersteunde bestanden',
    labelFileWaitingForSize: 'Wachten op bestandsgrootte',
    labelFileSizeNotAvailable: 'Bestandsgrootte niet beschikbaar',
    labelFileLoading: 'Aan het laden',
    labelFileLoadError: 'Fout opgetreden tijdens het laden',
    labelFileProcessing: 'Bezig met uploaden',
    labelFileProcessingComplete: 'Upload voltooid',
    labelFileProcessingAborted: 'Upload geannuleerd',
    labelFileProcessingError: 'Fout opgetreden tijdens het uploaden',
    labelFileProcessingRevertError: 'Fout opgetreden tijdens het ongedaan maken',
    labelFileRemoveError: 'Fout opgetreden tijdens het verwijderen',
    labelTapToCancel: 'Tik om te annuleren',
    labelTapToRetry: 'Tik om opnieuw te proberen',
    labelTapToUndo: 'Tik om ongedaan te maken',
    labelButtonRemoveItem: 'Verwijderen',
    labelButtonAbortItemLoad: 'Afbreken',
    labelButtonRetryItemLoad: 'Opnieuw',
    labelButtonAbortItemProcessing: 'Annuleren',
    labelButtonUndoItemProcessing: 'Ongedaan maken',
    labelButtonRetryItemProcessing: 'Opnieuw',
    labelButtonProcessItem: 'Upload',
    labelMaxFileSize: 'Maximale bestandsgroote is {filesize}',
    labelMaxTotalFileSize: 'Maximale totale bestandsgroote is {filesize}',
    labelMaxFileSizeExceeded: 'Maximale bestandsgroote overschreden',
    labelMaxTotalFileSizeExceeded: 'Maximale totale bestandsgroote overschreden',
    labelFileTypeNotAllowed: 'Bestandstype niet toegestaan',
    fileValidateTypeLabelExpectedTypes: 'Verwacht bestandstype {allTypes}',
    duplicateFileDialog: {
      title: 'Bestand bestaat al',
      description: 'Er bestaat al een bestand met de naam "{filename}" in deze folder',
      buttons: {
        cancel: 'Annuleren',
        resolve: 'Automatisch hernoemen',
        upsert: 'Overschrijven',
      },
    },
  },
  auditActions: {
    orderAccepted: 'Order geaccepteerd',
    customerNotified: 'Klant geinformeerd',
    orderFulfilled: 'Order fulfilment gestart',
    orderConfirmed: 'Order geaccepteerd',
    orderAllocated: 'Order voorraad toegewezen',
    calculationCreated: 'Offerte aangemaakt',
    orderCreated: 'Order aangemaakt',
    orderCanceled: 'Order geannuleerd',
    itemsAdded: 'Items toegevoegd',
  },
  auditActors: {
    system: 'Systeem',
  },
  auditCategories: {
    audit: 'Audit',
    request: 'Netwerkverzoek',
    error: 'Fout',
  },
  auditEntities: {
    order: 'Order',
    calculation: 'Offerte',
    invoice: 'Factuur',
    transaction: 'Transactie',
    user: 'Gebruiker',
    dataflow: 'Dataflow',
    contact: 'Contact',
    organisation: 'Organisatie',
    shipment: 'Verzending',
    list: 'Werklijst',
    parcel: 'Pakket',
  },
  properties: {
    path: 'Pad',
    signee: 'E-mailadres',
    reference: 'Referentie',
    amount: 'Bedrag',
    currency: 'Valuta',
    returnUrl: 'Terugsturen naar URL',
    amountDue: 'Te betalen bedrag',
    amountPaid: 'Betaald bedrag',
    isPaid: 'Betaald',
    secret: 'Sleutel',
    createdAt: 'Aangemaakt op',
    updatedAt: 'Bijgewerkt op',
    dueAt: 'Levering op',
    company: 'Bedrijf',
    description: 'Omschrijving',
    quantity: 'Aantal',
    message: 'Bericht',
    name: 'Naam',
    applyTo: 'Van toepassing op',
    operator: 'Conditie',
    type: 'Type',
    value: 'Waarde',
    constraints: 'Beperkingen',
    filters: 'Filters',
    adjustments: 'Kortingen',
    grantLimit: 'Limiet',
    priority: 'Prioriteit',
    activeAt: 'Actief vanaf',
    expiresAt: 'Verloopt op',
    code: 'Code',
    isActive: 'Actief',
    isConfigured: 'Ingesteld',
    givenName: 'Voornaam',
    given_name: 'Voornaam',
    familyName: 'Achternaam',
    family_name: 'Achternaam',
    additional_name: 'Tussenvoegsel',
    email: 'E-mailadres',
    phone_number: 'Telefoonnummer',
    dateOfBirth: 'Geboortedatum',
    organisation: 'Organisatie',
    phoneNumber: 'Telefoonnummer',
    country: 'Land',
    premiseNumber: 'Huisnummer',
    premise_number: 'Huisnummer',
    premise_number_suffix: 'Toevoeging',
    isPrimary: 'Primair',
    tags: 'Labels',
    cocNumber: 'KvK-nummer',
    registrationNumber: 'Btw-nummer',
    thoroughfare: 'Straat',
    locality: 'Plaats',
    postalCode: 'Postcode',
    postal_code: 'Postcode',
    administrativeArea: 'Administratief gebied',
    administrative_area: 'Administratief gebied',
    countryCode: 'Land',
    paymentTerm: 'Betaaltermijn (in dagen)',
    accountManager: 'Accountmanager',
    iban: 'IBAN',
    number: 'Nummer',
    spendingLimit: 'Uitgave limiet',
    currentDueAmount: 'Huidig openstaand bedrag',
    receiveInvoiceInEmail: 'Factuur ontvangen per e-mail',
    receiveInvoiceInMail: 'Factuur ontvangen per post',
    receiveInvoiceAtDelivery: 'Factuur ontvangen bij aflevering',
    setAsShippingAddress: 'Toevoegen als verzendadres',
    setAsBillingAddress: 'Toevoegen als factuuradres',
    afterwards: 'Achteraf',
    inAdvance: 'Vooraf',
    addAnotherProduct: 'Nog een product toevoegen',
    billingAddress: 'Factuuradres',
    shippingAddress: 'Verzendadres',
    paidAt: 'Betaald op',
    orderNumber: 'Ordernummer',
    invoiceNumber: 'Factuurnummer',
    subtotal: 'Subtotaal',
    total: 'Totaal',
    concept: 'Concept',
    isIncludingVat: 'Inclusief btw',
    invoicedAt: 'Gefactureerd op',
    client: 'Kanaal',
    customer: 'Klant',
    isConfirmed: 'Bevestigd',
    isAccepted: 'Geaccepteerd',
    isFinished: 'Afgerond',
    shippingMethod: 'Verzendmethode',
    servicePoint: 'Afhaalpunt',
    isSplitAllowed: 'Opsplitsen van verzending toestaan',
    yes: 'Ja',
    no: 'Nee',
    logo: 'Logo',
    calculation: 'Offerte',
    invoice: 'Factuur',
    order: 'Order',
    isLastRule: 'Gebruik als laatste regel',
    isLocked: 'Locked',
    deliveryAt: 'Verwachte levering op',
    delivery_at: 'Verwachte levering op',
    on: 'Aan',
    off: 'Uit',
    paymentMethod: 'Betaalmethode',
    paymentMethodIssuer: 'Bank',
    paymentProvider: 'betaalprovider',
    to: 'Naar',
    paid: 'Betaald',
    unpaid: 'Niet betaald',
    partlyPaid: 'Deels betaald',
    includingVat: 'Incl. btw',
    excludingVat: 'Excl. btw',
    confirmed: 'Bevestigd',
    accepted: 'Geaccepteerd',
    finished: 'Afgerond',
    inactive: 'Inactief',
    incomplete: 'Incompleet',
    externalStorages: 'Externe opslag',
    outbound: 'Uitgaand',
    expectedAt: 'Verwacht op',
    transaction: 'Transactie',
    payment: 'Betaling',
    isSettlement: 'Verrekening',
    isValid: 'Valide',
    isAvailable: 'Beschikbaar',
    isBackordered: 'Gebackordered',
    isBackorder: 'Backorder',
    isInbound: 'Inkomend',
    isReservation: 'Reservering',
    claimedAt: 'Geclaimd op',
    route: 'Route',
    deliveryRoute: 'Bezorgroute',
    collectRoute: 'Verzamelroute',
    coupon: 'Kortingscode',
    discount: 'Korting',
    discounts: 'Kortingen',
    conditions: 'Condities',
    restrictions: 'Restricties',
    from: 'Van',
    expected: 'Verwacht',
    available: 'Beschikbaar',
    vatSettings: 'Btw instellingen',
    rate: 'Tarief',
    arrivalAt: 'Arriveert',
    departureAt: 'Vertrek',
    transports: 'Transport',
    allocationProgress: 'Allocatie voortgang',
    billingProgress: 'Facturering voortgang',
    fulfilmentProgress: 'Fulfilment voortgang',
    expiresAfter: 'Vervalt na aantal dagen',
    isUnlimited: 'Ongelimiteerd',
    limit: 'Limiet',
    remaining: 'Resterend',
    pricingAt: 'Prijs op',
    location: 'Locatie',
    applyAvailableInventory: 'Beschikbare voorraad toepassen',
    lastAcceptedAt: 'Laatst geaccepteerd op',
    lastConfirmedAt: 'Laatst bevestigd op',
    orderTags: 'Order labels',
    defaultSettings: 'Standaard instellingen',
    inventoryOption: 'Voorraad optie',
    contact: 'Contact',
    vatNumber: 'BTW-nummer',
    vatCountryCode: 'BTW landcode',
    applyPricingRules: 'Prijsregels toepassen',
  },
  inventoryOptions: {
    referenced: 'Gematchte voorraad op inkooporder',
    backordered: 'Alle gebackorderde voorraad',
    available: 'Alle beschikbare voorraad',
  },
  entities: {
    order: 'Order',
    purchase: 'Inkooporder',
    invoice: 'Factuur',
  },
  filter: {
    type: 'Type',
    operator: 'Conditie',
    value: 'Waarde',
  },
  adjustment: {
    description: 'Omschrijving',
    percentage: 'Percentage',
    amount: 'Bedrag',
    isDiscount: 'Korting',
  },
  betweenOptions: {
    from: 'Van',
    to: 'Tot en met',
  },
  ordersSection: {
    title: 'Gerelateerde orders',
  },
  errors: {
    validation: {
      empty: '{target} mag niet leeg zijn',
      urlHasProtocol: "{target} dient te beginnen met 'https://' of 'http://'",
      validEmailFormat: 'Vul een geldig e-mail adres in',
      required: '{target} mag niet leeg zijn',
      validEmail: 'Vul een geldig e-mail adres in',
      validIBAN: 'Vul een geldig IBAN nummer in',
      url: '{target} dient een geldige URL te zijn',
      null: '{target} mag niet leeg zijn',
      integer: '{target} moet een geheel getal zijn',
      minLength: '{target} moet minstens {min} karakters lang zijn',
      maxLength: '{target} mag maximaal {max} karakters lang zijn',
      minNumber: '{target} moet minimaal {min} zijn',
      maxNumber: '{target} moet kleiner zijn of gelijk aan {max}',
      minItems: '{target} moet minimaal {min} items bevatten',
      maxItems: '{target} mag maximaal {max} items bevatten',
      atLeastOneNormalCharacter: '{target} mag niet alleen speciale tekens bevatten',
      emailAlreadyUsed: 'E-mailadres al in gebruik',
    },
  },
  datePicker: {
    datePlaceholder: 'dd/mm/jjjj',
    dateTimePlaceholder: 'dd/mm/jjjj uu:mm',
    cancelLabel: 'ANNULEREN',
    clearLabel: 'LEGEN',
    okLabel: 'OK',
    todayLabel: 'VANDAAG',
    toolbarTitle: 'SLECTEER EEN DATUM',
  },
  relativeDate: {
    properties: {
      quantity: 'Aantal',
      dayOfWeek: 'Dag van de week',
      dayOfMonth: 'Dag van de maand',
      type: 'Type',
      time: 'Tijd',
    },
    dateTypeOptions: {
      minutes: 'Minuten',
      hours: 'Uren',
      days: 'Dagen',
      weeks: 'Weken',
      months: 'Maanden',
    },
  },
  shippingMethodFormSection: {
    title: 'Verzendmethode',
  },
  couponsFormSection: {
    title: 'Kortingscodes',
    emptyMessage: 'Nog geen kortingscodes ingevoerd',
    feedback: {
      couponAdded: 'Kortingscode is toegevoegd aan de order',
      couponNotAdded: 'Kortingscode kon niet aan de order worden toegevoegd',
      couponRemoved: 'Kortingscode is verwijderd van de order',
      couponNotRemoved: 'Kortingscode kon niet worden verwijderd van de order',
    },
  },
  addCouponDrawer: {
    title: 'Kortingscode invoeren',
  },
  components: {
    autocomplete: {
      clearText: 'Legen',
      loadingText: 'Laden...',
      noOptionsText: 'Geen opties',
      openText: 'Open',
    },
    dataflowDrawer: {
      title: 'Dataflows',
      feedback: {
        dataFlowFinished: 'Dataflow is afgerond',
        dataFlowFailed: 'Er is iets mis gegaan tijdens het uitvoeren van de dataflow',
        dataFlowUnmatched: 'Voor deze dataflow wordt niet aan de juiste voorwaarden voldaan',
        noDataflows: 'Geen dataflows gevonden',
      },
    },
    addressForm: {
      fields: {
        organisation: {
          helpText: {
            sendCloudWarning:
              'Om fouten te voorkomen met SendCloud raden we aan niet meer dan 35 tekens te gebruiken in dit veld, op dit moment {length}',
          },
        },
      },
    },
  },
  paymentMethods: {
    providers: {
      tenant: 'Eigen beheer',
    },
    tenant: {
      cod: 'Contant bij aflevering',
      on_account: 'Op rekening',
      bank_transfer: 'Bank overschrijving',
      cash: 'Contant',
      manual_gift_card: 'Cadeaubon manueel',
      manual_card_transaction: 'Kaarttransactie manueel',
    },
  },
  bulkProductDrawer: {
    title: 'Meerdere producten toevoegen',
    columns: {
      sku: 'SKU',
      quantity: 'Aantal',
    },
  },
  productInventoryTable: {
    headers: {
      location: 'Locatie',
      available: 'Beschikbaar',
    },
    emptyMessage: 'Geen voorraad beschikbaar',
  },
  orderItemsGrid: {
    previewActions: {
      changeRoute: 'Route wijzigen',
    },
    changeRouteDrawer: {
      title: 'Route wijzigen',
    },
    feedback: {
      routeChanged: 'Route gewijzigd',
      routeNotChanged: 'Route kon niet worden gewijzigd',
    },
  },
  itemsList: {
    emptyMessage: 'Geen items',
  },
  orderProgressStatus: {
    done: 'Afgerond',
    pending: 'In afwachting',
  },
  sessionErrorDialog: {
    title: 'Ongeldige sessie',
    description:
      'Je sessie is verlopen of er heeft een fout plaats gevonden. Log opnieuw in om door te gaan met je sessie.',
    supportDescription:
      'Indien je deze melding direct weer te zien krijgt nadat je opnieuw bent ingelogd. Neem dan contact op met Afosto support.',
    actions: {
      loginAgain: 'Opnieuw inloggen',
    },
  },
};

export default translations;
